import { jwtDecode } from "jwt-decode";

export abstract class AuthHelper {

  public static GetUser() : any {
    const currentUserObject = localStorage.getItem('currentUser');

    if (currentUserObject) {
        const currentUser = JSON.parse(currentUserObject);

        return currentUser;
    }

    return '';
  }

  public static GetUserId(): any {
    const currentUser = this.GetUser();

    if (currentUser !== '')
    {
      return currentUser.id;
    }

    return 0;
  }

  public static GetUserFullName(): string {
    const currentUser = this.GetUser();

    if (currentUser !== '')
    {
      return currentUser.fullName;
    }

    return '';
  }

  public static GetUserName(): string {
    const currentUser = this.GetUser();

    if (currentUser !== '')
    {
      return currentUser.username;
    }

    return '';
  }

  public static GetRawToken() : string {

    const currentUser = this.GetUser();

    if (currentUser !== '')
    {
      return currentUser.auth_token;
    }

    return '';
  }

  public static GetToken() : string {

    const token = this.GetRawToken();

    if (token !== '')
    {
      const tokenDecoded: any = jwtDecode(token);

      return tokenDecoded;

    }

    return '';
  }

  public static CheckClaims(claims: string[]): boolean {
    const tokenDecoded: string = this.GetToken();
    if (tokenDecoded !== '') {
      const groups: Array<string> = tokenDecoded['cognito:groups'];

      var claimTrue = false;

      for (let i = 0; i < claims.length; i++) {
        if (groups.indexOf(claims[i]) >= 0)
        {
          claimTrue = true;
          break;
        }
      }

      return claimTrue;
    }

    return false;
  }

  public static CheckClaim(claim: string): boolean {
    return this.CheckClaims([claim]);
  }

  // ADMIN TECHNOLOGY PROVIDER
  public static IsAdminProvider(): boolean { return this.CheckClaim('ewd-admin-providers'); }

  // TECHNOLOGY PROVIDER
  public static IsAdmin(): boolean { return this.CheckClaim('ewd-admin'); }

  // CARRIER ADMIN
  public static IsCarrierAdmin(): boolean { return this.CheckClaim('ewd-carrier-admin'); }

  // RECORD KEEPER
  public static IsRecordKeeper(): boolean { return this.CheckClaim('ewd-record-keeper'); }

  // DRIVER
  public static IsDriver(): boolean { return this.CheckClaim('ewd-driver'); }
}
